// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"d303483f","223":"a5e50ef5","321":"f9357864","433":"85e78449","573":"e167cb81","830":"f5764779"}[chunkId] + ".chunk.js";
};